import { Component, inject } from '@angular/core';
import {
  ActionComponent,
  ListView,
  ListViewProviderDirective
} from '@ntap/core';
import { combineLatest, map, Observable } from 'rxjs';
import { PremjestiService } from './premjesti.service';
import { AppUser, AuthService, EMPTY } from '@app/components/login.component';
import {
  isDisabledActionForNerazvrstano,
  isMoveActionDisabled
} from '@app/shared/util/jedinica-gradiva-security-utils';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';

@Component({
  selector: 'app-premjesti-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./premjesti-action.component.scss']
})
export class PremjestiActionComponent extends withTooltipState(
  ActionComponent
) {
  private listViewProvider = inject(ListViewProviderDirective<ListView>);
  private premjestiService = inject(PremjestiService);
  private originalTooltip: string;

  user$: Observable<AppUser | EMPTY>;

  constructor(public authService: AuthService) {
    super();

    this.user$ = this.authService.user$;
  }

  protected override doChangedInputParam(): void {
    super.doChangedInputParam();
    this.originalTooltip = this.action.tooltip;
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = combineLatest([
      this.listViewProvider.selectedItems$,
      this.user$
    ]).pipe(
      map(([selectedItems, user]) => {
        const disabledState = isMoveActionDisabled(selectedItems, user);
        this.action.tooltip = disabledState.message || this.originalTooltip;
        return (
          isDisabledActionForNerazvrstano(selectedItems) ||
          disabledState.disabled
        );
      })
    );
  }

  override execute() {
    this.premjestiService.openPremjestanjeDialog(true);
  }
}
